export default __webpack_public_path__ + "static/media/14.f99942e9.png";